import { ACTIVE_STATUS, parseNumber } from "@/constants";
import { useState} from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { BaseDialog } from "./dialog";
import MultipleSelector from "../ui/multiple-selector";
import { JOB_TITLE_OPTIONS, TOOLS_SKILLS } from "@/profile.constants";
import { MONTHLY_RATE as MONTHLY_RATES } from "@/profile.constants";
import { InputWithAlert } from "../ui/input-with-alert";
import { Combobox } from "../ui/combobox";
import { SelectWithAlert } from "../ui/select-with-alert";
export const processCandidateFilter = (filter) => {
  const transformAutocompleteValueToFilter = (valueArray, field) => {
    return {
      field: field,
      value: valueArray.map((e) => e.value),
    };
  };

  let marketing = null;
  if (filter.marketing !== "all") {
    marketing = transformAutocompleteValueToFilter(
      [{ value: filter.marketing}],
      "marketing",
    );
  }

  let interested = null;
  if (filter.interested !== "all") {
    interested = transformAutocompleteValueToFilter(
      [{ value: filter.interested}],
      "interested",
    );
  }
  let result = {
    jobTitles: transformAutocompleteValueToFilter(filter.jobTitles ?? [], 'jobTitles'),
    knowledges: transformAutocompleteValueToFilter(filter.tools ?? [], 'knowledges'),
    monthlyRates: transformAutocompleteValueToFilter(filter.monthlyRate ?? [], 'monthlyRates'),
    experience: {
      field: 'experience',
      value: [filter.experience]
    },
    availability: {
      field: 'availability',
      value: [filter.availability]
    },
  }
  if(marketing ) {
    result = {
      ...result,
      marketing
    }
  }
  if(interested) {
    result = {
      ...result,
      interested
    }
  }
  return result;
}
export const CandidatesFilter = ({ onFilterChange, currentFilter }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [jobTitles, setJobTitles] = useState(currentFilter?.jobTitles ?? []);
  const [tools, setTools] = useState(currentFilter?.tools ?? []);
  const [experience, setExperience] = useState(currentFilter?.experience ?? undefined);
  const [availability, setAvailability] = useState(currentFilter?.availability ?? undefined);
  const [interested, setInterested] = useState(currentFilter?.interested ?? null);
  const [marketing, setMarketing] = useState(currentFilter?.marketing ?? null);

  const [monthlyRate, setMonthlyRate] = useState(currentFilter?.monthlyRate ? currentFilter?.monthlyRate[0] : undefined);
  const updateFilter = () => {
    let filters = {
      jobTitles,
      tools,
      experience,
      availability,
      interested,
      marketing
      //hourlyRatePeriod,
    };
    if (monthlyRate) {
      filters = {
        ...filters,
        monthlyRate: [monthlyRate] // Nothing is more permanent than temporary solution
      }
    }
    onFilterChange(filters);
  }
  return (
    <BaseDialog
      dialogTitle={t('filter')}
      buttonText={t('filter')}
      open={open}
      setOpen={
        (open) => {
          setOpen(open)
          if (!open) {
            updateFilter()
          }
        }
      }
    >
      <div className="w-[500px] py-6">
        <div className="w-full">
          <div className="pb-10">

            <MultipleSelector
              options={JOB_TITLE_OPTIONS}
              label={"Job titles/roles"}
              errorMessage={t("empty_data_invalid")}
              badgeClassName="bg-emerald-100 hover:bg-emerald-100 text-black"
              value={jobTitles}
              onChange={(newSelected) => {
                setJobTitles(newSelected)
              }}
              placeholder={"Job titles/roles"}
              inputClassName={"h-12 bg-white"}
            />
            <MultipleSelector
              options={TOOLS_SKILLS}
              label={"Technology stack/tools"}
              placeholder={"Technology stack/tools"}
              badgeClassName="bg-emerald-100 hover:bg-emerald-100 text-black"
              errorMessage={t("empty_data_invalid")}
              value={tools}
              onChange={(e) => {
                setTools(e);
              }}
              inputClassName={"h-12 mb-4 bg-white "}
            />
            <div className="pb-2">
              <Combobox
                className={"my-2 h-10 mb-5"}
                key={monthlyRate?.value}
                label={"Monthly rate from (USD)"}
                placeholder={"Monthly rate from (USD)"}
                creatable
                value={monthlyRate}
                errorMessage={t("empty_data_invalid")}
                options={MONTHLY_RATES}
                onChange={(newValue) => {
                  console.log(newValue)
                  setMonthlyRate(newValue);
                }}
              />
            </div>
            <div className="pb-2">
              <InputWithAlert
                value={experience}
                onChange={(e) => {
                  const value = parseNumber(e.target.value);
                  if (value <= 40) {
                    setExperience(value);
                  }
                }}
                label={"Experience From"}
                inputClassName={"h-10"}
              />
            </div>
            <div className="pb-2">
              <InputWithAlert
                value={availability}
                onChange={(e) => {
                  const value = parseNumber(e.target.value);
                  if (value <= 200) {
                    setAvailability(value);
                  }
                }}
                label={"Availability From (hours)"}
                inputClassName={"h-10"}
              />
            </div>
          </div>

          <div className="pb-2">
          <SelectWithAlert
            value={interested}
            onChangeValue={(e) => setInterested(e)}
            label={"Interested in project"}
            options={ACTIVE_STATUS(t).map((i) => {
              return {
                value: i.id,
                label: i.value,
                id: i.id,
              };
            })}
          />
          </div>

          <div className="pb-2">
            <SelectWithAlert
            value={marketing}
            onChangeValue={(e) => setMarketing(e)}
            label={"Marketing"}
            options={ACTIVE_STATUS(t).map((i) => {
              return {
                value: i.id,
                label: i.value,
                id: i.id,
              };
            })}
            />
          </div>
          <div className="w-full flex justify-end">
            <Button className="mr-4" variant="outline" onClick={() => {
              setOpen(false)
            }}>{t("common:button_clean_filter")}</Button>
            <Button className="" onClick={() => {
              updateFilter();
              setOpen(false);
            }}>{t("common:button_save")}</Button>
          </div>
        </div>
      </div>
    </BaseDialog>
  )
}
